module.exports = __webpack_public_path__ + "img/user-minus-alt.3f38954a.svg";